import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08 2.5 2.5 0 0 0 4.91.05L12 20V4.5Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16 8V5c0-1.1.9-2 2-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 13h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18h6a2 2 0 0 1 2 2v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20.5 21a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18.5 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BrainCircuit";
const BrainCircuit = memo(themed(Icon));
export {
  BrainCircuit
};
//# sourceMappingURL=brain-circuit.js.map
